/* @flow */
import * as React from "react";
import L from "react-loadable";

import Spinner from "./Spinners/BrandSpinner";
import UpdateScreen from "./UpdateScreen";
import { trackOnTimeline } from "./common/Timing";

function LoadingComponent(props) {
  if (props.isLoading) {
    return <Spinner />;
  }

  if (props.error) {
    return <UpdateScreen />;
  }

  return null;
}

function Loadable(loader: () => Promise<*>, label: string) {
  return L({
    LoadingComponent,
    loader() {
      return trackOnTimeline(loader(), "Lazy Component: " + label);
    }
  });
}

export default Loadable;



// WEBPACK FOOTER //
// ./src/components/Loadable.js